import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom'
import ReactTableWithPaginationComponent from '../../../components/table/ReactTableWithPaginationComponent'
import fileNumberSequenceService from '../../../services/systemConfiguration/fileNumberSequence/fileNumberSequenceService'
import ViewFileNumberSequence from './ViewFileNumberSequence'
import ModifyFileNumberSequence from './ModifyFileNumberSequence'
import { FileNumberSequenceModel } from '../../../models/systemConfiguration/fileNumberSequence/fileNumberSequenceModel'

const FileNumberSequenceComponent = () => {
  const [list, setList] = useState<FileNumberSequenceModel[]>([])
  const [schemeFilter, setSchemeFilter] = useState('')
  const [districtFilter, setDistrictFilter] = useState('')
  const { path } = useRouteMatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    async function load() {
      const resp = await fileNumberSequenceService.apiGetList()
      // apiManager may return { data: undefined } on failures; keep react-table safe.
      setList(resp.status === 200 && Array.isArray(resp.data) ? resp.data : [])
    }
    load()
  }, [location.pathname])

  const columns = React.useMemo(
    () => [
      { Header: 'Scheme', accessor: 'scheme' },
      { Header: 'District Number', accessor: 'districtNumber' },
      { Header: 'Scheme Max Number', accessor: 'schemeMaxNumber' },
      { Header: 'District Max Number', accessor: 'districtMaxNumber' },
      { Header: 'File Number Max', accessor: 'fileNumberMaxNumber' },
      {
        Header: 'Action',
        accessor: 'id',
        Cell: (e: any) => {
          const id = e?.row?.original?.id
          return (
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={(evt) => {
                evt.stopPropagation()
                history.push(`${path}/modify/${id}`)
              }}
            >
              Modify
            </button>
          )
        },
      },
    ],
    [history, path]
  )

  const filteredList = list.filter((row: any) => {
    const schemeOk =
      !schemeFilter ||
      String(row?.scheme || '')
        .toLowerCase()
        .includes(schemeFilter.toLowerCase())
    const districtOk =
      !districtFilter ||
      String(row?.districtNumber ?? '').includes(String(districtFilter))
    return schemeOk && districtOk
  })

  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Row className="title-layout">
          <Col className="d-flex justify-content-start">
            <span className="m-2">File Number Sequence</span>
          </Col>
        </Row>
        <Row className="role-and-permission-body-layout mt-4">
          <Col sm={12} className="mb-4">
            <Row>
              <Col sm={4}>
                <Form.Control
                  placeholder="Filter by Scheme"
                  value={schemeFilter}
                  onChange={(e) => setSchemeFilter(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Form.Control
                  placeholder="Filter by District Number"
                  value={districtFilter}
                  onChange={(e) => setDistrictFilter(e.target.value)}
                />
              </Col>
              <Col sm={4} className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setSchemeFilter('')
                    setDistrictFilter('')
                  }}
                >
                  Reset
                </button>
              </Col>
            </Row>
          </Col>
          <Col sm={12}>
            <ReactTableWithPaginationComponent
              columns={columns}
              data={filteredList}
            />
          </Col>
        </Row>
      </Route>
      <Route path={`${path}/view/:id`} component={ViewFileNumberSequence} />
      <Route path={`${path}/modify/:id`} component={ModifyFileNumberSequence} />
    </Switch>
  )
}

export default FileNumberSequenceComponent
